function isLikelyInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // Heurísticas de navegação embutida
  const isStandaloneApp = window.navigator.standalone === true;
  const hasNoReferrer = document.referrer === '';
  const isNotInIframe = window.self === window.top;
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Heurística baseada em navegador limitado
  const limitedFeatures =
    typeof window.webkit === 'undefined' && typeof window.chrome === 'undefined';

  // Se não for iframe, mas não tiver referrer, for touch device e com recursos limitados...
  return (
    isTouchDevice &&
    isNotInIframe &&
    hasNoReferrer &&
    limitedFeatures &&
    !/Safari|Chrome|Firefox|Edg|Opera/i.test(ua) // Evita navegadores padrão
  );
}

function isInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  const knownApps = [
    "FBAN", "FBAV", "Instagram", "Line", "Twitter", "TikTok", "Snapchat", "Messenger"
  ];

  const isKnownApp = knownApps.some(app => ua.includes(app));
  const isHeuristic = isLikelyInAppBrowser();

  return isKnownApp || isHeuristic;
}

document.addEventListener("DOMContentLoaded", function () {
  if (isInAppBrowser()) {
    const interval = setInterval(() => {
      const loginBtn = document.querySelector('div[name="hiko-container"]');
      if (loginBtn) {
        clearInterval(interval);
        loginBtn.style.display = 'none';
      }
    }, 300);
  }
});